/* TODO: t() */
let VALID_COORDINATE = /^-?\d+(\.\d+)?$/;
let VALID_SIZE = /^\d+$/;

export function isValidCoordinate(coor: string) {
  return VALID_COORDINATE.test(coor);
}

export function isValidSize(size: string) {
  return VALID_SIZE.test(size);
}
